import { ICON__list_check_solid } from '@/assets/icons_fa';
import { EKeyCode } from '@/enums/e_key_code';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { Key } from '@/enums/key';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON__navigation_desktop } from '../desktop/BUTTON__navigation_desktop';
import { ButtonNavigationMobile } from '../mobile/ButtonNavigationMobile';
import { PROPS__button_navigation } from './PROPS__button_navigation';

export function BUTTON__navigation_user_tasks() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { global_is_mobile, global_need_show_first_animation } = use_slice_ui(['global_is_mobile', 'global_need_show_first_animation']);
  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);
  const { user_tasks_map } = use_slice_generation(['user_tasks_map']);

  const is_visible = useMemo(() => get_is_visible(), [current_workspace_user, workspace_current, user_tasks_map]);

  const shortcut_key = Key.E;
  const shortcut_key_codes = [EKeyCode.E];

  /*
   * METHODS
   */

  function get_is_visible() {
    let user_permitted_to_view_entities = current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_USER_TASK_VIEW);

    let workspace_current_has_shared_entity =
      Array.from(user_tasks_map.values()).filter(item => item.workspace_id == workspace_current._id && item.is_shared).length > 0;

    return user_permitted_to_view_entities || workspace_current_has_shared_entity;
  }

  let props: PROPS__button_navigation = {
    global_need_show_first_animation,
    page_type: ENUM__page_type.USER_TASK_WITHOUT_PARAMS,
    tooltip_title: t(i18n_base_ui.sidebar_navigation.tabs.user_tasks.tooltip.title, { shortcut_key: shortcut_key.toUpperCase() }),
    title: t(i18n_base_ui.sidebar_navigation.tabs.user_tasks.title),
    Icon: ICON__list_check_solid,
  };

  /*
   *
   */

  if (!is_visible) return <></>;

  return global_is_mobile ? <ButtonNavigationMobile {...props} /> : <BUTTON__navigation_desktop {...props} {...{ shortcut_key_codes }} />;
}
